<substitute-editor [userId]="userId | async"></substitute-editor>
